/* AQUAWELLA native-variant UX enhancement: never replaces Shopify's variant or cart mechanics. */
(() => {
  const PICKER = 'variant-selects.aw5-variant-picker';
  const findSet = (picker) => picker.querySelector('.aw5-set-group input[type="radio"]:checked')?.value || '';
  const syncIncluded = (picker) => {
    const complete = /complete/i.test(findSet(picker));
    picker.querySelectorAll('[data-aw5-complete-only]').forEach((el) => { el.hidden = !complete; });
    picker.querySelectorAll('[data-aw5-essential-only]').forEach((el) => { el.hidden = complete; });
  };
  const getSelected = (picker) => [...picker.querySelectorAll('fieldset')].map((field) => field.querySelector('input[type="radio"]:checked')?.value || '');
  const matchingMedia = (picker) => {
    const data = picker.querySelector('[data-aw5-variant-media]');
    if (!data) return null;
    if (!data._aw5Variants) {
      try { data._aw5Variants = JSON.parse(data.textContent); } catch { data._aw5Variants = []; }
    }
    const chosen = getSelected(picker);
    return data._aw5Variants.find((v) => v.options.length === chosen.length && v.options.every((val, i) => val === chosen[i])) || null;
  };
  const warmImage = (media) => {
    if (!media?.imageUrl) return;
    if (!warmImage.cache) warmImage.cache = new Set();
    if (warmImage.cache.has(media.imageUrl)) return;
    warmImage.cache.add(media.imageUrl);
    const img = new Image();
    img.decoding = 'async';
    img.src = media.imageUrl;
  };
  const enhance = (picker) => {
    syncIncluded(picker);
    const m = matchingMedia(picker);
    if (!m) return;
    warmImage(m);
    const gallery = picker.closest('product-info')?.querySelector('media-gallery');
    if (!gallery || !m.mediaId) return;
    const slide = [...gallery.querySelectorAll('[data-media-id]')].find((el) => el.dataset.mediaId === m.mediaId && el.classList.contains('product__media-item'));
    if (slide) {
      const img = slide.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      gallery.setActiveMedia?.(m.mediaId, false);
    }
  };
  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.(PICKER);
    if (!picker || !event.target.matches('input[type="radio"],select')) return;
    // Capture on document is deliberately not used: let native variant-selects process the same event.
    enhance(picker);
  });
  document.addEventListener('pointerover', (event) => {
    const label = event.target.closest?.('label.aw5-color-chip, label.aw5-set-card');
    if (!label) return;
    const picker = label.closest(PICKER);
    if (!picker) return;
    const input = document.getElementById(label.htmlFor);
    if (!input || input.checked) return;
    // Predict next variant without changing a single Shopify input.
    const chosen = getSelected(picker);
    const position = [...picker.querySelectorAll('fieldset')].indexOf(input.closest('fieldset'));
    if (position < 0) return;
    chosen[position] = input.value;
    const data = picker.querySelector('[data-aw5-variant-media]');
    if (!data) return;
    if (!data._aw5Variants) {
      try { data._aw5Variants = JSON.parse(data.textContent); } catch { data._aw5Variants = []; }
    }
    const media = data._aw5Variants.find((v) => v.options.length === chosen.length && v.options.every((val, i) => val === chosen[i]));
    warmImage(media);
  });
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll(PICKER).forEach(syncIncluded));
})();
